import React from 'react';
import "./QuoteBlock.css";

/**
 * QuoteBlock
 *
 * @param props
 * @returns {*}
 * @constructor
 */
const QuoteBlock = (props) => {

    let {quote, author, source} = props;

    return (
        <div className="quote">
            <blockquote>{quote}</blockquote>
            <p className="author"><span> -{author}, </span><span>{source}</span></p>
        </div>
    )
};

export default QuoteBlock;



// WEBPACK FOOTER //
// ./src/components/QuoteBlock/QuoteBlock.jsx